export default __webpack_public_path__ + "static/media/ganzkoerper-reward-logo.9b4d1ae4.svg";